export function errorOccurredWhile(verbNoun?: string): string {
    return `An error occurred${
        verbNoun ? ` while ${verbNoun}` : ''
    }. Try again later or contact IT for support.`;
}
